const EventBus = window.EventBus;
export const SpaPagination = {
  template: `
  <div :class="(paginatorType =='text') ? 'px-8 lg:px-12 py-4 lg:py-8' : ''" v-if="pageCount > 1">
    <nav class="page-nav flex justify-center lbx-paginator-nav">
        <div v-if="currentPage != 1 && paginatorType =='icon'" class="pt-3 pr-5 cursor-pointer left-arrow" @click="down">
            <svg class="fill-current text-dark left-arrow-svg hover:text-light" width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 9L15 0.339745L15 17.6603L0 9Z"></path>
            </svg>
        </div>
        <div v-if="paginatorType =='text'" :class="currentPage == 1 ? 'text-darkGrey' : ''" class="w-1/2 md:w-auto pt-3 order-2 lg:order-1 pr-5 cursor-pointer left-text" @click="down">
            <div class="left-text-content" :class="currentPage == 1 ? 'text-darkGrey border-darkGrey' : ''" >Previous</div>
        </div>
        <div :class="(paginatorType =='text') ? 'flex order-1 justify-center w-full lg:w-auto lg:order-2 pb-2 paginator-items' : 'flex w-auto'">
        <p class="hover:text-light p-2 text-center cursor-pointer font-semibold text-lg first-page" 
        :class="(1 == currentPage) ? 'text-light selected-page' : 'text-dark no-selected-page'"
        @click="goToPage(1)">1</p>
        <p v-if="1 != from && pageCount > 5" class="text-dark p-2 text-center cursor-pointer font-semibold text-lg pag-dots">...</p>
        <p class="hover:text-light p-2 text-center cursor-pointer font-semibold text-lg"
        :class="(page == currentPage) ? 'text-light selected-page' : 'text-dark no-selected-page'"
        v-for="(page,index) in getPaginate" :key="index" @click="goToPage(page)">{{page}}</p>
        <p v-if="pageCount != to && pageCount > 5" class="text-dark p-2 text-center cursor-pointer font-semibold text-lg pag-dots">...</p>
        <p class="hover:text-light p-2 text-center cursor-pointer font-semibold text-lg last-page" 
        :class="(pageCount == currentPage) ? 'text-light selected-page' : 'text-dark no-selected-page'"
        @click="goToPage(pageCount)">{{pageCount}}</p>
        </div>
        <div  v-if="currentPage != pageCount && paginatorType =='icon'" class="pt-3 pl-5 cursor-pointer right-arrow" @click="up">
            <svg class="fill-current text-dark hover:text-light right-arrow-svg" width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 9L0 17.6603L0 0.339746L15 9Z"></path>
            </svg>
        </div>
        <div  v-if="paginatorType =='text'" :class="currentPage == pageCount ? 'text-darkGrey' : ''" class="w-1/2 md:w-auto pt-3 order-3 pl-5 cursor-pointer right-text" @click="up">
            <div class="right-text-content">Next</div>
        </div>
    </nav>
  </div>
  `,
  props: {
    ipp: {
      type: Number,
      required: true,
      default: 0
    },
    count: {
      type: Number,
      required: true,
      default: 0
    },
    currentPage: {
      type: Number,
      required: true,
      default: 0
    },
    slug: {
      type: String,
      required: true
    },
    paginatorType: {
      type: String,
      required: true
    }
  },
  data(){
    return {
      maxPages: 5,
      from: 0,
      to: 0
    }
  },
  methods: {
    updateUrl(page){
      var pathname = window.location.pathname;
      var query = window.location.search || '';
      if(!query)
        history.replaceState({}, null, pathname + "?pag=" + page);
      else {
        var queryPage = query.match(/pag=[0-9]+/);
        var newQueryPage = "pag=" + page;
        var newQuery = query.replace(queryPage, newQueryPage);
        history.replaceState({}, null, pathname + newQuery);
      }
    },
    down(){
      if (this.currentPage > 1) this.goToPage(this.currentPage - 1);
    },
    goToPage(page){
      EventBus.$emit('goToPage', page);
      var offsetTop = this.$parent.$refs['top-inventory'].offsetTop;
      window.scrollTo(0, offsetTop);
    },
    up() {
      if (this.currentPage < this.pageCount) this.goToPage(this.currentPage + 1);
    },
  },
  computed: {
    pageCount(){
      if(this.ipp <= 0 || this.count <= 0)
        return 0;

      return Math.ceil(this.count / this.ipp);
    }, 
    getPaginate() {
      var arrayPage = [];

      if(this.pageCount < 5){

        for(i = 2; i < this.pageCount; i++)
          arrayPage.push(i);

      return arrayPage;
      } else {
        this.from = this.currentPage - 1;
        this.to = this.currentPage + 1;
  
        if (this.from < 1) this.from = 1;
        if (this.to > this.pageCount) this.to = this.pageCount;
  
        for (let a = this.from; a <= this.to; a++) {
          arrayPage.push(a);
        }
  
        arrayPage = arrayPage.filter(number => number != 1 && number != this.pageCount)
        
        var iterations = 3 - arrayPage.length;
        for(var i = 1; i <= iterations; i++)
        {
          if(this.from == 1)
            arrayPage.push(arrayPage[arrayPage.length - 1] + 1);
          if(this.to == this.pageCount)
            arrayPage.unshift(arrayPage[0] - 1);
        }
  
        return arrayPage;
      }
    },
  },
  watch: {
    currentPage(p)
    {
      this.updateUrl(p);
    }
  }
}